import styled from "styled-components";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const TitleModalStyled = styled.h4`
  margin: 0;
  line-height: 1.42857143;
  font-weight: bold;
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
`;
const SubtitleModalStyled = styled.span`
  word-wrap: break-word;
`;

export { PageContainer, TitleModalStyled, SubtitleModalStyled };
